import { useState, useCallback, useEffect } from 'react'
import { Message, Button } from '@iqueue/ui-kit'
import SettingsPresenter from '../../api/SettingsPresenter'
import CodeMirror from '@uiw/react-codemirror'
import { javascript } from '@codemirror/lang-javascript'

const defaultCode = `
  \n/**\n * This function is used to get instantaneous well flow rate from given attributes.\n * \n * Attributes:\n * pw: pressure well\n * pp: pressure plume\n * t: temperature\n * pd: plume diameter\n * pl: plume length\n * pt: pipe thickness\n * \n * Given attributes can be nullable or undefined.\n */\nfunction instantaneousWellFlowRate(pw, pp, t, pd, pl, pt) {}\n\n({ instantaneousWellFlowRate })\n
`

function extractFunction(codeString) {
  const match = codeString.match(/function\s+instantaneousWellFlowRate\s*\(.*?\)\s*\{[^]*?\}/)
  return match ? match[0].trim() : ""
}

export default function SettingCodeMirror() {
  const [code, setCode] = useState(defaultCode)

  const handleCodeChange = useCallback((value) => {
    setCode(value)
  }, [])

  const handleSubmit = useCallback(async () => {
    await SettingsPresenter.post('instantaneous-well-flow-rate-formula', { fn: extractFunction(code) })
      .then(() => {
        Message({
          type: 'success',
          timeout: 3000,
          title: 'Формула успешно сохранена!',
        })
      })
      .catch((error) => {
        Message({
          type: 'error',
          timeout: 3000,
          subtitle: 'Серийный номер: ' + error?.message,
          title: 'Ошибка сохранения формулы',
        })
      })
  }, [code])

  useEffect(() => {
    const fetchData = async () => {
      await SettingsPresenter.get('instantaneous-well-flow-rate-formula').then(code => setCode(code)).catch(() => setCode(defaultCode))
    }
    fetchData().catch(() => setCode(defaultCode))
  }, [])

  return <div className="settings-box-mirror">
    <CodeMirror
      value={ code }
      height="100%"
      extensions={ [javascript()] }
      onChange={ handleCodeChange }
      className="settings-code-mirror"
      theme="dark"
      basicSetup={ {
        lineWrapping: true,
      } }
    />
    <div className="submit-button">
      <Button onClick={ handleSubmit } primary>
        Отправить
      </Button>
    </div>
  </div>

}
